// benefitsValidation.js

// Функция проверки украинского имени
const validateUkrainianName = (name) => {
  if (!name) return false;
  
  const ukrainianRegex = /^[А-ЩЬЮЯҐЄІЇа-щьюяґєії'\s-]+$/;
  return ukrainianRegex.test(name);
};

// Функция проверки даты (не может быть в будущем)
const validateNotFutureDate = (date) => {
  if (!date) return false;
  
  const inputDate = new Date(date);
  const today = new Date();
  today.setHours(23, 59, 59, 999); // Конец дня сегодня
  
  return inputDate <= today;
};

// Функция проверки возраста (не старше 8 лет)
const validateChildAge = (birthDate, maxAge = 8) => {
  if (!birthDate) return false;
  
  const birth = new Date(birthDate);
  const today = new Date();
  
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  
  return age <= maxAge;
};

// Функция проверки РНОКПП (10 цифр)
const validateRnokpp = (rnokpp) => {
  if (!rnokpp) return false;
  
  const rnokppRegex = /^\d{10}$/;
  return rnokppRegex.test(rnokpp);
};

// Функция проверки номера свидетельства о рождении
const validateBirthCertificate = (certificate) => {
  if (!certificate) return false;
  
  const certificateRegex = /^[А-Я]{2}-\d{6}$/;
  return certificateRegex.test(certificate);
};

// Основная функция валидации формы пільг
export const validateBenefitsForm = (formData) => {
  const errors = {};
  const benefits = formData.benefits || {};

  // Если пільга выбрана, проводим полную валидацию
  if (benefits.type) {
    const selectedBenefit = benefits.type.toLowerCase();

    // Проверка для обычных пільг (с документами)
    if (!selectedBenefit.includes('територія обслуговування') && 
        !selectedBenefit.includes('брати та сестри') && 
        !selectedBenefit.includes('працівників')) {
      
      if (!benefits.documentType) {
        errors.benefitsDocumentType = 'Тип документа обов\'язковий';
      }

      if (!benefits.documentNumber) {
        errors.benefitsDocumentNumber = 'Номер документа обов\'язковий';
      }

      if (!benefits.issuedTo) {
        errors.benefitsIssuedTo = 'Поле "Кому видано" обов\'язкове';
      } else if (!validateUkrainianName(benefits.issuedTo)) {
        errors.benefitsIssuedTo = 'ФІО має містити тільки українські літери';
      }

      if (!benefits.issueDate) {
        errors.benefitsIssueDate = 'Дата видачі обов\'язкова';
      } else if (!validateNotFutureDate(benefits.issueDate)) {
        errors.benefitsIssueDate = 'Дата видачі не може бути у майбутньому';
      }

      if (!benefits.files || benefits.files.length === 0) {
        errors.benefitsFiles = 'Фото чи скан-копія документа обов\'язкові';
      }
    }

    // Проверка для пільги "Територія обслуговування"
    if (selectedBenefit.includes('територія обслуговування')) {
      if (!benefits.address) {
        errors.benefitsaddress = 'Адреса проживання обов\'язкова';
      }
    }

    // Проверка для пільги "Брати та сестри в одному ЗДО"
    if (selectedBenefit.includes('брати та сестри') || selectedBenefit.includes('сестри в одному здо')) {
      if (!benefits.kindergarten) {
        errors.benefitsKindergarten = 'Заклад дошкільної освіти обов\'язковий';
      }

      if (!benefits.siblingBirthCertificate) {
        errors.benefitsSiblingBirthCertificate = 'Номер свідоцтва про народження обов\'язковий';
      } else if (!validateBirthCertificate(benefits.siblingBirthCertificate)) {
        errors.benefitsSiblingBirthCertificate = 'Номер свідоцтва має бути у форматі: СР-123456';
      }

      if (!benefits.siblingName) {
        errors.benefitsSiblingName = 'Ім\'я дитини обов\'язкове';
      } else if (!validateUkrainianName(benefits.siblingName)) {
        errors.benefitsSiblingName = 'Ім\'я дитини має містити тільки українські літери';
      }

      if (!benefits.siblingBirthDate) {
        errors.benefitsSiblingBirthDate = 'Дата народження дитини обов\'язкова';
      } else if (!validateChildAge(benefits.siblingBirthDate)) {
        errors.benefitsSiblingBirthDate = 'Вік дитини не може перевищувати 8 років';
      }
    }

    // Проверка для пільги "Діти працівників закладу"
    if (selectedBenefit.includes('працівників закладу') || selectedBenefit.includes('працівників здо')) {
      if (!benefits.kindergarten) {
        errors.benefitsKindergarten = 'Заклад дошкільної освіти обов\'язковий';
      }

      if (!benefits.employeeName) {
        errors.benefitsEmployeeName = 'Ім\'я працівника обов\'язкове';
      } else if (!validateUkrainianName(benefits.employeeName)) {
        errors.benefitsEmployeeName = 'Ім\'я працівника має містити тільки українські літери';
      }

      if (!benefits.employeeRnokpp) {
        errors.benefitsEmployeeRnokpp = 'РНОКПП працівника обов\'язковий';
      } else if (!validateRnokpp(benefits.employeeRnokpp)) {
        errors.benefitsEmployeeRnokpp = 'РНОКПП має містити рівно 10 цифр';
      }
    }
  }

  return errors;
};

// Вспомогательная функция для проверки, есть ли ошибки
export const hasBenefitsErrors = (errors) => {
  return Object.keys(errors).length > 0;
};

export default {
  validateBenefitsForm,
  hasBenefitsErrors,
  validateUkrainianName,
  validateNotFutureDate,
  validateChildAge,
  validateRnokpp,
  validateBirthCertificate
};